export const PERSEUS_CLIENT_ID_STORE_KEY = 'glv_perseus_client_id'
export const PERSEUS_SESSION_STORE_KEY = 'glv_perseus_session'
export const SESSION_TTL = 30 * 60 * 1000
export const CLIENT_ID_TTL = 2 * 366 * 24 * 60 * 60 * 1000
